import { useTranslation } from 'react-i18next';
import { AdviceCard } from './AdviceCard';
import { adviceText } from './adviceText';
import type { IAttentionCardsProps } from './IAttentionCardsProps';

/** «Що потребує уваги» на огляді модуля (прототип v4): перші три поради повними реченнями у тонах важливості, без кнопок дій. */
export function AttentionCards({ items, stageLabel }: IAttentionCardsProps) {
  const { t } = useTranslation();
  return (
    <section className="mp-panel">
      <strong className="mp-panel__title">{t('overview.attention')}</strong>
      {items.map((item) => <AdviceCard key={item.key} item={item} text={adviceText(item, t, stageLabel)} />)}
    </section>
  );
}
